import { REACT_APP__POLOTNO_API_KEY } from "@smp/utils";
import { API, polotnoShapesList, URLS } from "polotno/utils/api";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "polotno.shapes";

const isPolotnoResponse = (resp: any): resp is PolotnoPayload => "hits" in resp;

type PolotnoPayload = {
  hits: number;
  items: Array<{ url: string }>;
};

type NounProjectPayload = {
  generated_at: string;
  icons: Array<{
    id: string;
    icon_url: string;
  }>;
};

export type PolotnoShapesPayload = string[];

export const useQueryPolotnoShapes = (
  query?: string,
  options?: Omit<UseQueryOptions<PolotnoShapesPayload>, "queryKey" | "queryFn">,
) =>
  useQuery<PolotnoShapesPayload>(
    [KEY, query],
    () =>
      fetch(
        query
          ? `${API}/get-nounproject?query=${query}&KEY=${REACT_APP__POLOTNO_API_KEY}`
          : polotnoShapesList(),
      )
        .then((resp) => {
          if (resp.ok) {
            return resp.json() as Promise<PolotnoPayload | NounProjectPayload>;
          }

          throw new Error("Api error");
        })
        .then((resp) => {
          if (isPolotnoResponse(resp)) {
            return resp.items.map(({ url }) => url);
          } else {
            return resp.icons.map(({ id }) => URLS.nounProjectDownload(id));
          }
        })
        .catch(() => {
          throw new Error("Api error");
        }),
    {
      keepPreviousData: true,
      ...options,
    },
  );

useQueryPolotnoShapes.KEY = KEY;
